/** @format */

import createMutation from "../create-mutation";

//create company
export const useCreateCompany = createMutation({
  url: "/company",
  method: "POST",
});

//update company by id
export const useUpdateCompanyById = createMutation({
  url: (company_id) => `/company/${company_id}`,
  method: "PATCH",
});

//create company account by company id
export const useCreateCompanyAccountByCompanyID = createMutation({
  url: (company_id) => `/company/${company_id}/account`,
  method: "POST",
});

//delete logo by company id
export const useDeleteLogoByCompanyID = createMutation({
  url: (company_id) => `/company/${company_id}/logo`,
  method: "DELETE",
});

//update logo by company id
export const useUpdateLogoByCompanyID = createMutation({
  url: (company_id) => `/company/${company_id}/logo`,
  method: "PATCH",
});

//create logo by company id
export const useCreateLogoByCompanyID = createMutation({
  url: (company_id) => `/company/${company_id}/logo`,
  method: "POST",
});

//create company account
export const useCreateCompanyAccount = createMutation({
  url: "/company/account",
  method: "POST",
});

//delete company account by account id
export const useDeleteCompanyAccountByAccountID = createMutation({
  url: (account_id) => `/company/account/${account_id}`,
  method: "DELETE",
});

//delete company account by company id & user id
export const useDeleteCompanyAccountByCompanyIDUserID = createMutation({
  url: (company_id, user_id) =>
    `/company/${company_id}/user/${user_id}/account`,
  method: "DELETE",
});

//update company account by account id
export const useUpdateCompanyAccountByAccountID = createMutation({
  url: (account_id) => `/company/account/${account_id}`,
  method: "PATCH",
});

//update company account by company id & user id
export const useUpdateCompanyAccountByCompanyUserID = createMutation({
  url: (company_id, user_id) =>
    `/company/${company_id}/user/${user_id}/account`,
  method: "PATCH",
});

//delete company me
export const useDeleteCompanyMe = createMutation({
  url: "/company/me",
  method: "DELETE",
});

//update company me
export const useUpdateCompanyMe = createMutation({
  url: "/company/me",
  method: "PATCH",
});

//create company plan
export const useCreateCompanyPlan = createMutation({
  url: "/company/plan",
  method: "POST",
});

//update company plan by id
export const useUpdateCompanyPlanByID = createMutation({
  url: (company_plan_id) => `/company/plan/${company_plan_id}`,
  method: "PATCH",
});

//create company subscription
export const useCreateCompanySubscription = createMutation({
  url: "/company/subscription",
  method: "POST",
});

//update company subscription by id
export const useUpdateCompanySubscriptionByID = createMutation({
  url: (subscription_id) => `/company/subscription/${subscription_id}`,
  method: "PATCH",
});
